'use client'

import React from 'react'

import { cn, stripParagraphTags } from '../../../../utils'

import { HeroAButtons } from './a-hero-a-buttons'

import type { IButtonProps } from '../../../../components/button/m-button'

export interface IHeroAContentProps {
	eyebrow?: string
	title: string
	text: string
	buttons: IButtonProps[]
	className?: string
}

export const HeroAContent: React.FC<IHeroAContentProps> = ({
	eyebrow,
	title,
	text,
	buttons,
	className
}) => {
	// Strip <p> tags from headings for proper rendering
	const cleanTitle = stripParagraphTags(title)
	const cleanEyebrow = eyebrow ? stripParagraphTags(eyebrow) : ''

	return (
		<div className={cn('m-hero-a__content', className)}>
			{cleanEyebrow !== '' && (
				<h4 className='m-hero-a__eyebrow'>
					{cleanEyebrow.includes('<') ? (
						<span dangerouslySetInnerHTML={{ __html: cleanEyebrow }} />
					) : (
						cleanEyebrow
					)}
				</h4>
			)}
			<h1 className='m-hero-a__title'>
				{cleanTitle.includes('<') ? (
					<span dangerouslySetInnerHTML={{ __html: cleanTitle }} />
				) : (
					cleanTitle
				)}
			</h1>
			<div className='m-hero-a__text' dangerouslySetInnerHTML={{ __html: text }} />
			<HeroAButtons buttons={buttons} />
		</div>
	)
}

HeroAContent.displayName = 'AHeroAContent'
